import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { APIURL } from "../../../Global";
import axios from "axios";
import "../../ConfigDashboard/config.css";

function VerifyAdd(props) {
    const [otp, setOtp] = useState("");
    const [error, setError] = useState(false);
    const [method, setMethod] = useState("");

    const login_datas = JSON.parse(sessionStorage.getItem("logindatas")) || null;

    const handleOtpChange = (e) => {
        setOtp(e.target.value);
    };

    const handleMethodChange = (e) => {
        setMethod(e.target.value);

        let data = {};
        if (e.target.value === "Email ID") {
            data = { email: login_datas.email };
        } else {
            data = { code: login_datas.country_code, mobile_number: login_datas.mobile_number };
        }

        axios
            .post(`${APIURL}/api/v1/account/send-otp/`, data, {
                headers: { "Content-Type": "application/json" },
            })
            .catch(() => {
                console.error("Error sending OTP");
            });
    };

    const submitOTP = () => {
        let data = {};
        if (method === "Email ID") {
            data = { email: login_datas.email, otp: otp, requested_user: login_datas.user_type };
        } else {
            data = { code: login_datas.country_code, mobile_number: login_datas.mobile_number, otp: otp, requested_user: login_datas.user_type };
        }

        axios
            .post(`${APIURL}/api/v1/account/verify-otp/`, data, {
                headers: { "Content-Type": "application/json" },
            })
            .then((res) => {
                if (res.data.status === "success") {
                    sessionStorage.setItem("verified_login", true);
                    props.onSuccess(); // ✅ Call success function only on success
                } else {
                    setError(true);
                }
            })
            .catch(() => {
                setError(true);
            });
    };

    return (
        <Modal show={props.show} centered size="lg" onHide={props.onHide}> {/* ✅ Control visibility using props.show */}
            <Modal.Body style={{ textAlign: "left", display: "flex", flexDirection: "column" }}>
                <div style={{ maxWidth: "900px" }}>
                    <div style={{ backgroundColor: "aliceblue" }}><br />
                        <h6 className="title_config">Verify OTP</h6>
                        <div style={{ justifyContent: "center" }}>
                            <span style={{ marginLeft: "30%" }} className="text-style-here">
                                Where do you want to receive the OTP?
                            </span>
                            <select className="boxpwdverify" value={method} onChange={handleMethodChange}>
                                <option value="" hidden>*Select</option>
                                <option value="Email ID">Email</option>
                                <option value="Phone Number">Phone</option>
                            </select>
                            {method && <small style={{ marginLeft: "32%" }}>OTP has been sent to your registered {method}</small>}
                        </div>
                        <br />
                        <div style={{ justifyContent: "center", textAlign: "center" }}>
                            <input value={otp} name="otp" type="text" className="boxpwd" onChange={handleOtpChange} />
                            {error && (
                                <div style={{ zIndex: "auto", width: "237px" }} className="error-validation-msg">
                                    Invalid OTP
                                </div>
                            )}
                        </div>
                        <br />
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <button onClick={submitOTP} className="save">SUBMIT</button>
                            <span>&nbsp;&nbsp;&nbsp;</span>
                            <button onClick={props.onHide} className="edit">CANCEL</button>
                        </div>
                        <br /><br />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default VerifyAdd;
